<template>
  <v-autocomplete
    v-model="itensSelecionados"
    v-on="inputListeners"
    :items="itemsComputed"
    item-text="nome"
    item-value="id"
    v-bind="$attrs"
    v-bind:value="modelValue"
    :loading="loading"
    :disabled="disabled"
  >
    {
    <template #progress>
      <v-progress-linear
        style="position: absolute"
        height="2px"
        :color="cor_loading"
        indeterminate
      ></v-progress-linear>
    </template>

    <template #prepend-item v-if="multiplaSelecao && items.length">
      <v-list-item
        v-if="itensSelecionados.length === items.length"
        class="pl-14px py-2"
        @click.prevent="itensSelecionados = []"
      >
        <v-icon class="pl-2" color="primary">mdi-checkbox-marked</v-icon>
        <span class="ml-2 font-weight-medium">Desmarcar Todos</span>
      </v-list-item>

      <v-list-item
        v-else
        class="pl-14px py-2"
        @click.prevent="itensSelecionados = Helpers.arrayColumn(items, 'id')"
      >
        <v-icon class="pl-2" v-if="itensSelecionados.length > 0" color="primary">mdi-minus-box</v-icon>
        <v-icon class="pl-2" v-else>mdi-checkbox-blank-outline</v-icon>
        <span class="ml-2 font-weight-medium">Selecionar Todos</span>
      </v-list-item>

      <v-divider />
    </template>

    <template #selection="{item}" v-if="multiplaSelecao">
      <template v-if="modelValue.indexOf(item.id) < qtde_visivel_selecionados">
        <span>{{item.nome}}</span><template v-if="apendarVirgula(item)">,&nbsp;</template>
      </template>

      <template v-if="modelValue.indexOf(item.id) === qtde_visivel_selecionados">
        <span class="ml-1 text-grat-900">(+ {{modelValue.length - qtde_visivel_selecionados}})</span>
      </template>
    </template>

    <template v-for="(_, slot) of $scopedSlots" #[slot]="scope">
      <slot :name="slot" v-bind="scope"/>
    </template>

    <template #prepend-inner>
      <slot name="prepend-inner" />
    </template>
  </v-autocomplete>
</template>

<script>
import {buscarCompradores} from "@/api/Comprador";
import {arrayColumn, logout} from "@/helpers";

export default {
  name: "SysCompradorAutocomplete",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: [Number, String, Array],
      required: true
    },
    qtde_visivel_selecionados: {
      type: [Number],
      default: 4
    },
    unshiftItems: {
      validator: function (value) {
        const keys = Object.keys(value);
        return typeof value === "object" && keys.includes('id') && keys.includes('nome')
      }
    },
    cor_loading: {
      type: String,
      default: 'red'
    },
    idsGrupo: {
      type: Array,
      default: () => ([])
    },
    idsFilial: {
      type: Array,
      default: () => ([])
    },
    idsSegmento: {
      type: Array,
      default: () => ([])
    },
    idsSecao: {
      type: Array,
      default: () => ([])
    },
    desabilitarJoin: {
      type: Boolean,
      default: false
    },
    selecionar_comprador_pedido_compra_se_unico: {
      type: [String, Number],
      default: null
    },
    desabilitar_carteira_comprador_limitacao_visualizacao: {
      type: Boolean,
      default: false
    },
  },
  data: () => ({
    items: [],
    loading: false,
    disabled: false,
    timer_buscar_items: null
  }),
  computed: {
    itemsComputed() {
      if (this.unshiftItems && this.unshiftItems.id != null && this.unshiftItems.nome != null) {
        const jaIncluido = this.items.some(item => String(item.id) === String(this.unshiftItems.id));
        return jaIncluido ? this.items : [this.unshiftItems].concat(this.items);
      }
      return this.items;
    },
    itensSelecionados: {
      get: function () {
        return this.modelValue;
      },
      set: function (valor) {
        if ([null, undefined].includes(valor)) {
          valor = this.$attrs.multiple ? [] : '';
        }

        this.$emit("update:modelValue", valor)
      },
    },
    multiplaSelecao () {
      return ![null, undefined].includes(this.$attrs.multiple)
    },
    inputListeners: function () {
      const vm = this

      return Object.assign({},
        vm.$listeners, {
          input: function (values) {
            vm.itensSelecionados = values;
          }
        }
      )
    }
  },
  watch: {
    idsGrupo(novo, antigo) {
      this.verificaAtualizacaoFiltros(novo, antigo);
    },
    idsFilial(novo, antigo) {
      this.verificaAtualizacaoFiltros(novo, antigo);
    },
    idsSegmento(novo, antigo) {
      this.verificaAtualizacaoFiltros(novo, antigo);
    },
    idsSecao(novo, antigo) {
      this.verificaAtualizacaoFiltros(novo, antigo);
    }
  },
  mounted() {
    this.loading = true;
    this.getItems();
  },
  methods: {
    verificaAtualizacaoFiltros(novo, antigo) {
      if (novo.length !== antigo.length) {
        clearTimeout(this.timer_buscar_items);
        this.timer_buscar_items = setTimeout(this.getItems, 2000);
      }
    },
    getItems () {
      this.loading = true;

      const parametros = {
        grupos: this.idsGrupo,
        filiais: this.idsFilial,
        segmentos: this.idsSegmento,
        secoes: this.idsSecao,
        desabilitarJoin: this.desabilitarJoin,
        selecionar_comprador_pedido_compra_se_unico: this.selecionar_comprador_pedido_compra_se_unico,
        desabilitar_carteira_comprador_limitacao_visualizacao: this.desabilitar_carteira_comprador_limitacao_visualizacao ? 'S' : 'N'
      };

      buscarCompradores(parametros)
        .then(items => {
          this.items = items;
          this.loading = false;
          this.atualizarFiliaisSelecionadas();

          if (this.selecionar_comprador_pedido_compra_se_unico) {
            const filter = this.items.find(item => item.unico_em_pedido_de_compra);
            this.itensSelecionados = filter ? filter.id : 1;
          }
        })
        .catch(logout);
    },
    atualizarFiliaisSelecionadas() {
      if (!this.multiplaSelecao) return;

      const novos_itens = this.items.filter(item => this.itensSelecionados.some(id => `${id}` === `${item.id}`));
      this.itensSelecionados = arrayColumn(novos_itens, 'id');
    },
    apendarVirgula (item) {
      const indexOf = this.modelValue.indexOf(item.id)
      return indexOf !== this.modelValue.length - 1 && indexOf < (this.qtde_visivel_selecionados - 1)
    }
  }
}
</script>

<style scoped>
.pl-14px {
  padding-left: 14px
}

.text-grat-900 {
  color: #999;
}
</style>
